module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_5010.e1f5bf16.png";